import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect } from "react";
import styles from "./AlertDialog.module.css";
const getIcon = (type) => {
    switch (type) {
        case "success":
            return (_jsxs("svg", { width: "48", height: "48", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", children: [_jsx("circle", { cx: "12", cy: "12", r: "10" }), _jsx("polyline", { points: "20 6 9 17 4 12" })] }));
        case "error":
            return (_jsxs("svg", { width: "48", height: "48", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", children: [_jsx("circle", { cx: "12", cy: "12", r: "10" }), _jsx("line", { x1: "12", y1: "8", x2: "12", y2: "12" }), _jsx("line", { x1: "12", y1: "16", x2: "12.01", y2: "16" })] }));
        case "warning":
            return (_jsxs("svg", { width: "48", height: "48", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", children: [_jsx("path", { d: "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z" }), _jsx("line", { x1: "12", y1: "9", x2: "12", y2: "13" }), _jsx("line", { x1: "12", y1: "17", x2: "12.01", y2: "17" })] }));
        case "info":
            return (_jsx("span", { className: "material-symbols-outlined", style: {
                    fontSize: "32px",
                    color: "#87B6A7",
                    fontVariationSettings: "'FILL' 1",
                }, children: "info" }));
        case "confirm":
            return (_jsx("svg", { width: "48", height: "48", viewBox: "0 0 24 24", fill: "#F25B22", children: _jsx("path", { d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" }) }));
    }
};
export const AlertDialog = ({ isOpen, options, onClose }) => {
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = "hidden";
        }
        else {
            document.body.style.overflow = "unset";
        }
        return () => {
            document.body.style.overflow = "unset";
        };
    }, [isOpen]);
    useEffect(() => {
        const handleEscape = (e) => {
            if (e.key === "Escape" && isOpen) {
                onClose(false);
            }
        };
        if (isOpen) {
            document.addEventListener("keydown", handleEscape);
            return () => document.removeEventListener("keydown", handleEscape);
        }
    }, [isOpen, onClose]);
    if (!isOpen || !options)
        return null;
    const type = options.type || "info";
    const isConfirm = type === "confirm";
    const title = options.title;
    const handleConfirm = () => {
        options.onConfirm?.();
        onClose(true);
    };
    const handleCancel = () => {
        options.onCancel?.();
        onClose(false);
    };
    return (_jsx("div", { className: styles.overlay, onClick: () => !isConfirm && handleCancel(), children: _jsxs("div", { className: styles.dialog, onClick: (e) => e.stopPropagation(), children: [isConfirm ? (_jsxs(_Fragment, { children: [_jsxs("div", { className: styles.confirmHeader, children: [_jsx("div", { className: `${styles.iconContainer} ${styles.iconInline} ${styles[type]}`, children: getIcon(type) }), title && _jsx("h3", { className: styles.titleInline, children: title })] }), options.message && (_jsx("div", { className: styles.content, children: _jsx("p", { className: styles.description, children: options.message }) }))] })) : (_jsxs(_Fragment, { children: [_jsx("div", { className: `${styles.iconContainer} ${styles[type]}`, children: getIcon(type) }), _jsxs("div", { className: styles.content, children: [title && _jsx("h3", { className: styles.title, children: title }), _jsx("p", { className: styles.message, children: options.message })] })] })), _jsxs("div", { className: styles.actions, children: [isConfirm && (_jsx("button", { type: "button", className: `${styles.button} ${styles.cancelButton}`, onClick: handleCancel, children: options.cancelText || "Cancel" })), _jsx("button", { type: "button", className: `${styles.button} ${styles.confirmButton} ${styles[type]}`, onClick: handleConfirm, autoFocus: true, children: options.confirmText || (isConfirm ? "Confirm" : "OK") })] })] }) }));
};
